<div [ngStyle]="showPreLine && { 'white-space': 'pre-line' } " [innerHTML]="data"></div>
